module.exports = __webpack_public_path__ + "static/media/part-5-1.f0527a76.webp";